import styled from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Container = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px;
    border-radius: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 60px minmax(0, 1fr);
    gap: 10px 15px;
  }
`;

export const AvatarBox = styled.div`
  width: 100px;
  min-width: 100px;
  height: 100px;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 60px;
    min-width: 60px;
    height: 60px;
    border-radius: 14px;
  }
`;

export const AvatarImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: contents;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`;

export const UserName = styled.h1`
  margin: 0;
  overflow: hidden;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 26px;
  font-weight: 500;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
    line-height: 1.2;
  }
`;

export const UserId = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 15px;
  line-height: 1;
`;

export const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-column: 1 / -1;
    width: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;
    ${removeScrollbar()}
  }
`;

export const Badge = styled.div<{ $variant?: 'confirmed' | 'date' }>`
  padding: 8px 15px;
  border-radius: 1000px;
  color: ${({ theme, $variant }) =>
    $variant === 'date' ? theme.palette.primary.labels : '#2a8143'};
  background: ${({ theme, $variant }) =>
    $variant === 'date' ? theme.palette.secondary.background : '#e0f4eb'};
  font-size: 13px;
  line-height: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;
